(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jamie-game"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-game]').forEach(function(root){
if(root.dataset.initialized)return;root.dataset.initialized='true';
var stage=root.querySelector('.jlg-stage'),bird=root.querySelector('.jlg-bird'),container=root.querySelector('.jlg-pipes'),overlay=root.querySelector('.jlg-overlay'),title=root.querySelector('[data-title]'),pause=root.querySelector('[data-pause]'),status=root.querySelector('[data-status]'),scoreNode=root.querySelector('[data-score]'),bestNode=root.querySelector('[data-best]');
var character='Meowl',scores=[],characterButtons=Array.from(root.querySelectorAll('[data-character]')),scoreList=root.querySelector('[data-scores]'),nameInput=root.querySelector('[data-player-name]'),fullButton=root.querySelector('[data-fullscreen]'),artLink=root.querySelector('[data-art-link]');
try{scores=JSON.parse(localStorage.getItem('jamie-arcade-scores')||'[]');if(!Array.isArray(scores))scores=[];scores=scores.filter(function(r){return r&&typeof r.name==='string'&&typeof r.character==='string'&&Number.isFinite(r.score)&&r.score>=0;}).slice(0,5);}catch(e){scores=[];}
function renderScores(){scoreList.replaceChildren();if(!scores.length){var empty=document.createElement('li');empty.textContent='No flights yet. Your name could be first.';scoreList.append(empty);}scores.forEach(function(r,i){var li=document.createElement('li'),text=document.createElement('span'),detail=document.createElement('small'),points=document.createElement('b');text.textContent=(i+1)+'. '+r.name;detail.textContent=r.character;text.append(detail);points.textContent=r.score;li.append(text,points);scoreList.append(li);});}
renderScores();
characterButtons.forEach(function(button){button.addEventListener('click',function(){if(mode==='playing'||mode==='paused')return;character=button.dataset.character;bird.querySelector('img').src=button.dataset.src;artLink.href=button.dataset.product;characterButtons.forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});mode='ready';y=225;v=0;pipes=[];container.replaceChildren();overlay.hidden=false;announce('Ready for take-off?');paint();});});
function fullState(on){root.classList.toggle('is-fullscreen',on);fullButton.textContent=on?'Exit full screen ×':'Full screen ⛶';fullButton.setAttribute('aria-pressed',String(on));}
fullButton.addEventListener('click',function(){if(root.classList.contains('is-fullscreen')){fullState(false);if(document.fullscreenElement===root)document.exitFullscreen().catch(function(){});}else{fullState(true);if(root.requestFullscreen)root.requestFullscreen().catch(function(){});}});
document.addEventListener('fullscreenchange',function(){if(!document.fullscreenElement)fullState(false);});
var mode='ready',y=225,v=0,score=0,best=0,pipes=[],elapsed=0,last=0;
try{best=Number(localStorage.getItem('jamie-meowl-best'))||0;}catch(e){}bestNode.textContent=best;
function announce(text){title.textContent=status.textContent=text;root.dataset.state=mode;characterButtons.forEach(function(b){b.disabled=mode==='playing'||mode==='paused';});nameInput.disabled=mode==='playing'||mode==='paused';}
function reset(){y=225;v=-240;score=0;pipes=[];container.replaceChildren();elapsed=0;scoreNode.textContent='0';mode='playing';overlay.hidden=true;pause.disabled=false;announce('Keep flapping — mind the frames!');stage.focus();}
function flap(){if(mode==='playing')v=-240;}
function finish(){if(mode!=='playing')return;mode='over';if(score>best){best=score;bestNode.textContent=best;try{localStorage.setItem('jamie-meowl-best',String(best));}catch(e){}}scores.push({name:(nameInput.value.trim()||'Player').slice(0,16),character:character,score:score});scores.sort(function(a,b){return b.score-a.score;});scores=scores.slice(0,5);try{localStorage.setItem('jamie-arcade-scores',JSON.stringify(scores));}catch(e){}renderScores();announce('Gallery mishap! Score: '+score);overlay.hidden=false;pause.disabled=true;}
function toggle(){if(mode==='playing'){mode='paused';announce('Taking a breather.');overlay.hidden=false;}else if(mode==='paused'){mode='playing';announce('Keep flapping — mind the frames!');overlay.hidden=true;stage.focus();}}
function spawn(){var top=65+Math.random()*175,gap=166,u=document.createElement('div'),l=document.createElement('div');u.className=l.className='jlg-pipe';u.style.top='0';u.style.height=(top/5)+'%';l.style.top=((top+gap)/5)+'%';l.style.height=((475-top-gap)/5)+'%';container.append(u,l);pipes.push({x:380,top:top,gap:gap,u:u,l:l,passed:false});}
function paint(){bird.style.top=(y/5)+'%';bird.style.transform='translateY(-50%) rotate('+Math.max(-20,Math.min(45,v*.09))+'deg)';pipes.forEach(function(p){p.u.style.left=p.l.style.left=(p.x/3.6)+'%';});}
function tick(now){var dt=Math.min((now-last)/1000,.033);last=now;if(mode==='playing'){elapsed+=dt;v+=650*dt;y+=v*dt;if(elapsed>=1.9){elapsed=0;spawn();}pipes.forEach(function(p){p.x-=(112+Math.min(score*2,35))*dt;if(!p.passed&&p.x+60<90){p.passed=true;scoreNode.textContent=++score;}if(107>p.x&&73<p.x+60&&(y-17<p.top||y+17>p.top+p.gap))finish();});pipes=pipes.filter(function(p){if(p.x< -65){p.u.remove();p.l.remove();return false;}return true;});if(y<20||y>454)finish();}paint();if(root.isConnected)requestAnimationFrame(tick);}
root.querySelector('[data-start]').addEventListener('click',function(e){e.stopPropagation();if(mode==='paused')toggle();else reset();});
root.querySelector('[data-flap]').addEventListener('click',function(){if(mode==='ready'||mode==='over')reset();else flap();});
pause.addEventListener('click',toggle);
stage.addEventListener('pointerdown',function(e){if(e.target.closest('button'))return;if(mode==='playing'){e.preventDefault();flap();}});
stage.addEventListener('keydown',function(e){if(e.key===' '||e.key==='ArrowUp'){e.preventDefault();if(mode==='ready'||mode==='over')reset();else flap();}else if(e.key==='Escape'){e.preventDefault();toggle();}});
document.addEventListener('visibilitychange',function(){if(document.hidden&&mode==='playing')toggle();});
announce('Ready for take-off?');paint();requestAnimationFrame(tick);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamie-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jl-work-carousel').forEach(function(carousel){
  if(carousel.dataset.ready)return;
  carousel.dataset.ready='true';
  var track=carousel.querySelector('.jl-carousel-track');
  var cards=Array.from(track.querySelectorAll('.jl-card'));
  var previous=carousel.querySelector('.jl-carousel-arrow--prev');
  var next=carousel.querySelector('.jl-carousel-arrow--next');
  var pause=carousel.parentElement.querySelector('.jl-carousel-pause');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  var paused=reduced.matches;
  var visible=false;
  var lastManual=0;
  function update(){pause.textContent=paused?'Play carousel':'Pause carousel';pause.setAttribute('aria-label',(paused?'Play':'Pause')+' featured works carousel');}
  function move(direction){
    var max=track.scrollWidth-track.clientWidth;
    if(max<5)return;
    var step=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
    var target=track.scrollLeft+direction*step;
    if(direction>0&&track.scrollLeft>=max-5)target=0;
    if(direction<0&&track.scrollLeft<=5)target=max;
    track.scrollTo({left:Math.max(0,Math.min(max,target)),behavior:reduced.matches?'auto':'smooth'});
  }
  function manual(direction){lastManual=Date.now();move(direction);}
  previous.addEventListener('click',function(){manual(-1);});
  next.addEventListener('click',function(){manual(1);});
  pause.addEventListener('click',function(){paused=!paused;update();});
  track.addEventListener('keydown',function(event){
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();manual(event.key==='ArrowRight'?1:-1);}
  });
  track.addEventListener('pointerdown',function(){lastManual=Date.now();},{passive:true});
  var observer=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;},{threshold:.35});
  observer.observe(carousel);
  var timer=window.setInterval(function(){
    if(!carousel.isConnected){window.clearInterval(timer);observer.disconnect();return;}
    if(paused||!visible||document.hidden||carousel.matches(':hover')||carousel.contains(document.activeElement)||Date.now()-lastManual<10000)return;
    move(1);
  },5000);
  reduced.addEventListener('change',function(event){if(event.matches){paused=true;update();}});
  update();
  function resize(){var overflowing=track.scrollWidth>track.clientWidth+5;previous.hidden=!overflowing;next.hidden=!overflowing;pause.hidden=!overflowing;}
  new ResizeObserver(resize).observe(track);
  resize();
});


  document.querySelectorAll('.jl-slideshow').forEach(function (carousel) {
    var slides = Array.from(carousel.querySelectorAll('.jl-slide'));
    var button = carousel.querySelector('.jl-slideshow-pause');
    var index = 0;
    var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === 0); slide.inert = i !== 0; });
    if (slides.length < 2) { button.hidden = true; return; }
    function updateButton() { button.textContent = paused ? 'Play' : 'Pause'; button.setAttribute('aria-label', (paused ? 'Play' : 'Pause') + ' artwork slideshow'); }
    updateButton();
    button.addEventListener('click', function () { paused = !paused; updateButton(); });
    window.setInterval(function () {
      if (paused || document.hidden || carousel.contains(document.activeElement) || carousel.matches(':hover')) return;
      slides[index].classList.remove('is-active'); slides[index].inert = true;
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active'); slides[index].inert = false;
    }, 5500);
  });

  document.querySelectorAll('.jl-follow').forEach(function (prompt) {
    var storageKey = 'jl-follow-dismissed-until';
    var dismissedUntil = 0;
    try { dismissedUntil = Number(localStorage.getItem(storageKey)) || 0; } catch (error) {}
    if (Date.now() < dismissedUntil) return;

    var ready = false;
    var shown = false;
    function maybeShow() {
      if (!ready || shown) return;
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY < scrollable * 0.28) return;
      shown = true;
      prompt.hidden = false;
      window.removeEventListener('scroll', maybeShow);
    }
    window.addEventListener('scroll', maybeShow, { passive: true });
    window.setTimeout(function () { ready = true; maybeShow(); }, 12000);
    prompt.querySelector('.jl-follow__dismiss').addEventListener('click', function () {
      prompt.hidden = true;
      window.removeEventListener('scroll', maybeShow);
      try { localStorage.setItem(storageKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000)); } catch (error) {}
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
